module.exports = __webpack_public_path__ + "img/Oluseun Onigbinde_Founder.e2bc5a5e.jpg";